import DashboardSortTableHeader from "./DashboardSortTableHeader";

export default DashboardSortTableHeader;
